export const getUser = state => {
  return state.user
}

export const isAuthenticated = state => {
  return state.isAuthenticated
}

export const getOrders = state => {
  return state.orders
}

export const getLinkOrders = state => {
  return state.linkOrders
}

export const getLinkOrder = state => {
  return state.linkOrder
}

export const getClients = state => {
  return state.clients
}

export const getPbns = state => {
  return state.pbns
}

export const getAppliedFilters = state => {
  return state.appliedFilters
}

export const getPbn = state => {
  return state.pbn
}

export const getFilters = state => {
  return state.pbnFilters
}

export const getLanguages = state => {
  return state.languages
}

export const getOrder = state => {
  return state.order
}

export const getReport = state => {
  return state.report
}

export const getBuildReport = state => {
  return state.buildReport
}

export const getUsers = state => {
  return state.userList
}

export const getUserRoles = state => {
  return state.userRoleList
}

export const getRegistrars = state => {
  return state.registrarList
}

export const getViewFilters = state => {
  return state.viewFilters
}

export const getHosts = state => {
  return state.hosts
}

export const getMaintenanceOrders = state => {
  return state.maintenanceOrders
}

export const getMaintenanceOrder = state => {
  return state.maintenanceOrder
}

export const getTask = state => {
  return state.task
}

export const getTasks = state => {
  return state.tasks
}

export const getTemplates = state => {
  return state.pbnTemplates
}

export const getTemplate = state => {
  return state.pbnTemplate
}

export const getPasswordVisibility = state => {
  return state.passwordVisibility
}

export const getPbnTypes = state => {
  return state.pbnTypes
}

export const getPpcData = state => {
  return state.ppcData
}

export const getBookmarks = state => {
  return state.userBookmarks
}

export const getData = state => {
  return state.dataStructures
}

export const getProjects = state => {
  return state.projects
}

export const getProjectTasks = state => {
  return state.projectTasks
}

export const getXeroAccounts = state => {
  return state.xeroAccounts
}

export const getXeroItems = state => {
  return state.xeroItems
}

export const getXeroContacts = state => {
  return state.xeroContacts
}

export const getXeroCategories = state => {
  return state.xeroCategories
}

export const getAffiliateCompanies = state => {
  return state.affiliateCompanies
}

export const getAffiliateCompany = state => {
  return state.affiliateCompany
}

export const getBrands = state => {
  return state.brands
}

export const getBrand = state => {
  return state.brand
}

export const getToplists = state => {
  return state.toplists
}

export const getToplist = state => {
  return state.toplist
}



// WEBPACK FOOTER //
// ./src/store/getters.js